function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d06716",
  fillRule: "nonzero",
  d: "M21.89 19.91c-.48 1.98-.85 4.13-1.17 5.57H8.65v-.89c1.59-1.78 3.34-3.66 4.82-5.63 2.1-2.84 3.31-5.4 3.31-7.99 0-2.36-1.09-4.06-3.16-4.06-1.81 0-3.04 1.43-4.03 3.04l-.88-.82 1.92-3.21c1.15-1.27 2.65-2.12 4.55-2.12 2.98 0 5.48 2.29 5.48 6.08 0 2.7-1.23 4.81-4.21 8.03l-3.61 3.89h4.91c1.8 0 2.05-.07 3.16-2.29l.98.4z"
});

var Svg2 = function Svg2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2.2c8c60b6.svg";
export { ForwardRef as ReactComponent };